// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.category-toggle .mini-toggle {
  position: absolute;
  display: inline-block;
  bottom: 20px;
  right: 20px;
}
.distributors-toggle .mini-toggle {
  position: absolute;
  display: inline-block;
  bottom: 20px;
  right: 40px;

  @media(max-width: 480px) {
    bottom: 10px;
  }
}
.media-toggle .mini-toggle {
  position: absolute;
  bottom: 10px;
  right: 50px;
}
.mini-toggle {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
  /* bottom: 20px; */
  /* right: 50px; */
}

.mini-toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background-color: #ccc;
  border-radius: 999px;
  transition: 0.2s;
}

.slider::before {
  content: "";
  position: absolute;
  height: 16px;
  width: 16px;
  left: 2px;
  top: 2px;
  background-color: white;
  border-radius: 50%;
  transition: 0.2s;
}

input:checked + .slider {
  background-color: #4ade80;
}

input:checked + .slider::before {
  transform: translateX(16px);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/toggle.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,WAAW;;EAEX;IACE,YAAY;EACd;AACF;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".category-toggle .mini-toggle {\n  position: absolute;\n  display: inline-block;\n  bottom: 20px;\n  right: 20px;\n}\n.distributors-toggle .mini-toggle {\n  position: absolute;\n  display: inline-block;\n  bottom: 20px;\n  right: 40px;\n\n  @media(max-width: 480px) {\n    bottom: 10px;\n  }\n}\n.media-toggle .mini-toggle {\n  position: absolute;\n  bottom: 10px;\n  right: 50px;\n}\n.mini-toggle {\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  height: 20px;\n  /* bottom: 20px; */\n  /* right: 50px; */\n}\n\n.mini-toggle input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  inset: 0;\n  background-color: #ccc;\n  border-radius: 999px;\n  transition: 0.2s;\n}\n\n.slider::before {\n  content: \"\";\n  position: absolute;\n  height: 16px;\n  width: 16px;\n  left: 2px;\n  top: 2px;\n  background-color: white;\n  border-radius: 50%;\n  transition: 0.2s;\n}\n\ninput:checked + .slider {\n  background-color: #4ade80;\n}\n\ninput:checked + .slider::before {\n  transform: translateX(16px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
